import useViewport from 'framework-ui-components/Components/V2/Hooks/useViewport';
import { useEffect } from 'react';
import { getWindowSizeToParam } from '../../../hooks/usePluginAppViewport';
import { PluginMessageTypes } from '../../../models/constants';
import MessagesPlugin from '../../../models/messages';

export default function useViewportResolutionSender() {
  const { width, height } = useViewport();

  useEffect(() => {
    if (width === undefined || height === undefined) return;
    MessagesPlugin.postMessageToChilds(
      PluginMessageTypes.SET_RESOLUTION, getWindowSizeToParam({
        innerHeight: height,
        innerWidth: width,
      }),
    );
  }, [width, height]);
}
